if(document.querySelectorAll(".productCollapsibleContent").length > 0) {
  var productCollapsibleTitles = document.querySelectorAll(".productCollapsibleContentTitle");
  for(let i=0; i<productCollapsibleTitles.length; i++) {
    let productCollapsibleTitle = productCollapsibleTitles[i];
    productCollapsibleTitle.addEventListener("click", function(e) {
      this.parentElement.classList.toggle('--open');
    });
  }
}